export default __webpack_public_path__ + "1afcbd62c5c10aba0c7b02895e320d87.png";